import React from 'react';
import { i18n } from '@lt/localization';
import { pluralizeHotels } from 'src/utils/pluralizeUtils';
import LoaderIcon from '@lt/components/icons-react/rebrand/Loader';
import styles from './filtersApply.module.css';

const getButtonText = (count) =>
  count
    ? `${i18n.t('filters.applyButton.show')} ${count} ${pluralizeHotels(count)}`
    : `${i18n.t('filters.applyButton.nothing')} ${pluralizeHotels(count)}`;

interface FiltersApplyProps {
  fetching?: boolean;
  applyFilters: () => void;
  hotelsCount: number;
}

export const FiltersApplyMobile = ({
  fetching = false,
  hotelsCount,
  applyFilters,
}: FiltersApplyProps) => (
  <button
    type="button"
    className={styles.button}
    onClick={applyFilters}
    disabled={fetching || !hotelsCount}
  >
    <span>
      {fetching ? (
        <LoaderIcon className={styles.loader} />
      ) : (
        getButtonText(hotelsCount)
      )}
    </span>
  </button>
);
